import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/MobileBottomNav.jsx");
